import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as reportActions from './../../actions/reportActions';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';
import styles from './../TradeBook/TradeBook.less';
import ModifyOpenTradeComponent from './ModifyOpenTradeComponent';
import OpenTradeAllocateComponent from './OpenTradeAllocateComponent';
import config from './../../config';
import Modal from 'react-modal';
import {ButtonToolbar,  DropdownButton,  MenuItem,  Tabs,  Tab,  Button,  Checkbox} from 'react-bootstrap';
import { Card } from 'reactstrap';
import {Grid,DragDropProvider,Table,TableHeaderRow,TableColumnReordering,ColumnChooser,TableColumnVisibility,SearchPanel,
  Toolbar,TableSelection} from '@devexpress/dx-react-grid-bootstrap4';
import {SortingState,IntegratedSorting,  SearchState, IntegratedFiltering,DataTypeProvider,SelectionState,IntegratedSelection} from '@devexpress/dx-react-grid';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import { TableCell } from '@material-ui/core//Table';
import numeral  from 'numeral';
import { applyStyle,getCountofTableRows,applyToHover,setDirection } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import track from 'react-tracking';

const elementsData = [
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"OpntrdModifyWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
	{"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
  {"classNames":"noDataColor", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table-container","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table-cell","elementType":"normal", "applyTo":"all", "tagNames":"td"},
  {"classNames":"card", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"popover", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-item", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
];
const directionData=[
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"trdbody", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"refresh_icon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"openTradeRowsCount", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"errorheader", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"nav-tabs","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbookText", "elementType":"normal", "applyTo":"all", "tagNames":"span"}
];
const getRowId = row => row.id;
import i18next from 'i18next';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};
@connect(state => ({
  opnTrdModifyFlag:state.dashboardRoot.tradeBookReducer.opnTrdModifyFlag,
  closeOpnTrdModifypopup:state.dashboardRoot.tradeBookReducer.closeOpnTrdModifypopup,
  opnTrdAllctFlag:state.dashboardRoot.tradeBookReducer.opnTrdAllctFlag,
  ordersCTID:state.dashboardRoot.activityReducer.ordersCTID,
  userDetail: state.auth.userDetail,
  status: state.dashboardRoot.instrumentListReducer.status,
  socketData: state.dashboardRoot.instrumentListReducer.socketData,
  tradeBookColumns: state.dashboardRoot.dashboardReducer.tradeBookColumns,
  language:state.dashboardRoot.commonReducer.language,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  fontSize: state.auth.userDetail.fontSize,
  navigationStatus: state.dashboardRoot.commonReducer.navigationStatus,
  opentradeBook:state.dashboardRoot.instrumentListReducer.opentradeBook,
  openTradeLoaderFlag:state.dashboardRoot.instrumentListReducer.openTradeLoaderFlag,
  openTrdRandomNoDB:state.dashboardRoot.instrumentListReducer.openTrdRandomNoDB,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  showOpenTradeAlert:state.dashboardRoot.tradeBookReducer.showOpenTradeAlert,
  openTradeMsg:state.dashboardRoot.tradeBookReducer.openTradeMsg
}), {
...reportActions,...tradeBookActions,...dashboardActions,...activityActions,...tradepanelActions,...authActions, ...commonActions
})

@track(() => ({ widgetDetails: { tab: i18next.t('openTrd') }}))

export default class OpenTradeComponent extends Component {
  static propTypes = {
    userDetail: PropTypes.object,
    opnTrdModifyFlag:PropTypes.bool,
    opnTrdAllctFlag:PropTypes.bool,
    ordersCTID:  PropTypes.array,
    openTrdRefreshFlag:PropTypes.func,
    updateTrdBookCols:PropTypes.func,
    layoutChanged:PropTypes.func,
    tradeBookColumns: PropTypes.array,
    language:PropTypes.string,
    navigationStatus: PropTypes.string,
    getInvoice: PropTypes.func,
    opentradeBook:PropTypes.object,
    getOpenTrdes: PropTypes.func,
    getPhysicalsRecord:PropTypes.func,
  };
  state = {
    randomNo: 0,
    openTradeRows:[],
    openTradeColumns:[],
    openTradeColumnsExtensions:[],
    openTradeColumnsExtensionsAR:[],
    integratedSortingColumnExtensions:[
      { columnName: 'price', compare: compareRate },
      { columnName: 'quantity', compare: compareRate },
    ],
    openTradeColumnOrder:['eventTime','deal','cmdtyPair','quantity','qtyType','price','Action','docNo'],
    hiddenOpenTradeOrderColNames:[],
    openTradeSearchValue:'',
    openTradeColsSorting:[],
    openTradeRandomNo:0,
    refreshIconFlag: false,
    selectedRowDocNo: '',
    selectedRowValues:'',
    openTradeRowCount: 0,
    enableOpentrdFlag:false,
    enableAllctMdlFlag:false,
    allocateRows:[],
    fetchAvailableQty:[],
    isDisplayAlert:false,
    displayMessage:'',
    isWidgetRefresh:false
  }
  constructor() {
     super();
     //openTrd
     this.onChangeOpenTrdColOrder = this.onChangeOpenTrdColOrder.bind(this);
     this.onChangeOpenTrdColSorting = this.onChangeOpenTrdColSorting.bind(this);
     this.onChangeHiddenOpenTrdCol = this.onChangeHiddenOpenTrdCol.bind(this);
     this.onChangeOpenTrdSearchValue = this.onChangeOpenTrdSearchValue.bind(this);
     //coloumnSelection
     this.openTrdColSelection = this.openTrdColSelection.bind(this);
     this.openAllocateMdl = this.openAllocateMdl.bind(this);
     this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  componentWillMount(){
    let openTrdColsExtension =[];
    let openTrdColsExtensionAR=[];
      openTrdColsExtension =[
        { columnName: 'eventTime',width: 190},
        { columnName: 'deal',width: 80},
        { columnName: 'cmdtyPair',width: 110},
        { columnName: 'quantity',width: 140,align: 'right'},
        { columnName: 'qtyType', width: 120},
        { columnName: 'price',width: 130,align: 'right'},
        { columnName: 'unrealisedPL',width: 130,align: 'right'},
        { columnName: 'Action',width: 150, sortingEnabled:false},
        { columnName: 'docNo',width: 140}
      ];
      openTrdColsExtensionAR =[
        { columnName: 'eventTime',width: 190,align: 'right'},
        { columnName: 'deal',width: 80,align: 'right'},
        { columnName: 'cmdtyPair',width: 110,align: 'right'},
        { columnName: 'quantity',width: 140,align: 'left'},
        { columnName: 'qtyType', width: 120,align: 'right'},
        { columnName: 'price',width: 130,align: 'left'},
        { columnName: 'unrealisedPL',width: 130,align: 'left'},
        { columnName: 'Action',width: 150, sortingEnabled:false},
        { columnName: 'docNo',width: 140,align: 'right'}
      ];

    this.setState({openTradeColumnsExtensions: openTrdColsExtension});
    this.setState({openTradeColumnsExtensionsAR: openTrdColsExtensionAR});
    let openTradeColumnOrder = this.props.tradeBookColumns.openTradeColumnOrder;
    // let openTradeColumnOrder=['eventTime','deal','cmdtyPair','quantity','qtyType','price','unrealisedPL','Action','docNo'];
    var openTrdColsArr =[];
    for(let i=0 ; i< openTradeColumnOrder.length ; i++){
      var obj ={};
      obj.name = openTradeColumnOrder[i];
      obj.title = (i18next.t(openTradeColumnOrder[i]));
      openTrdColsArr[i] = obj;
    }
    this.setState({openTradeColumnOrder: openTradeColumnOrder});
    this.setState({openTradeColumns:openTrdColsArr});
  }
  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    var tempArr=[];
    if(this.props.opentradeBook !== undefined){
	    if(this.props.opentradeBook.opentradesData!==undefined && this.props.opentradeBook.opentradesData!==null){
  	    this.props.opentradeBook.opentradesData.forEach(function(value,key){
  	    	tempArr=tempArr.concat(value);
  	    });
      }
    }
    this.setState({openTradeRows: tempArr});
    this.setState({openTradeRowCount: tempArr.length});
    this.setState({openTradeRandomNo: this.props.openTrdRandomNoDB});
    // this.setState({CTID:this.props.ordersCTID});
    this.setState({refreshIconFlag:this.props.openTradeLoaderFlag});
    this.setState({hiddenOpenTradeOrderColNames : this.props.tradeBookColumns.hiddenopenTradeOrderColumnNames});
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName("dropdown-item")[0], "classNames":"dropdown-item"}
    ];
    //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }

  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
   }
  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(nextProps.language !== this.props.language){
      //let lmtOutStandingOrderColumnOrder = nextProps.tradeBookColumns.lmtOutStandingOrderColumnOrder;
      let openTradeColumnOrder = this.props.tradeBookColumns.openTradeColumnOrder;
      // let openTradeColumnOrder=['eventTime','deal','cmdtyPair','quantity','qtyType','price','unrealisedPL','Action','docNo'];
      var openTrdColsArr =[];
      for(let i=0 ; i< openTradeColumnOrder.length ; i++){
        var obj ={};
        obj.name = openTradeColumnOrder[i];
        obj.title = (i18next.t(openTradeColumnOrder[i]));
        openTrdColsArr[i] = obj;
      }
      this.setState({openTradeColumns:openTrdColsArr});
    }
    if(nextProps.openTradeLoaderFlag !== this.props.openTradeLoaderFlag){
      this.setState({refreshIconFlag:nextProps.openTradeLoaderFlag});
    }
    if (nextProps.openTrdRandomNoDB !== this.state.openTradeRandomNo) {
      var openTradeRows = [];
      if(nextProps.opentradeBook !== undefined){
        if(nextProps.opentradeBook.opentradesData!== undefined){
          if(nextProps.opentradeBook.opentradesData !==null){
            nextProps.opentradeBook.opentradesData.forEach(function(value,key){
              openTradeRows=openTradeRows.concat(value);
            });
          }
        }
      }
      this.setState({openTradeRows:openTradeRows});
      this.setState({openTradeRandomNo: nextProps.openTrdRandomNoDB});
      this.props.openTrdRefreshFlag(false);
      var count=getCountofTableRows(openTradeRows,this.props.tradeBookColumns.openTradeColumnOrder,this.state.openTradeSearchValue);
      this.setState({openTradeRowCount: count});
    }
    if(this.props.showOpenTradeAlert !== nextProps.showOpenTradeAlert){
    if(nextProps.showOpenTradeAlert){// if recive 723 and open trade modal is open 
      this.props.closeOpnTrdModifypopup(false);
      this.setState({isDisplayAlert: true})
      this.setState({displayMessage:nextProps.openTradeMsg.errorMessage})
      this.setState({isWidgetRefresh:nextProps.openTradeMsg.isWidgetRefresh})
    }else{
      this.setState({isDisplayAlert: false, displayMessage:''})
    }
  }

    if(nextProps.navigationStatus !== this.props.navigationStatus){
      this.setState({selectedRowDocNo:''});
    }
  }
  //openTrd
  onChangeOpenTrdColOrder(newOrder) {
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.openTradeColumnOrder=newOrder;
      this.setState({ openTradeColumnOrder: newOrder });
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOpenTrdColOrder', component:"OpenTradeComponent"});
    }
  }
  onChangeOpenTrdColSorting(sorting) {
    try{
      this.setState({ openTradeColsSorting: sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOpenTrdColSorting', component:"OpenTradeComponent"});
    }
  }
  onChangeHiddenOpenTrdCol(hiddenOpenTradeOrderColNames){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenopenTradeOrderColumnNames=hiddenOpenTradeOrderColNames;
      this.setState({ hiddenOpenTradeOrderColNames : hiddenOpenTradeOrderColNames});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenOpenTrdCol', component:"OpenTradeComponent"});
    }
  };
  onChangeOpenTrdSearchValue(value){
    try{
      this.setState({openTradeSearchValue: value });
      var count=getCountofTableRows(this.state.openTradeRows,this.props.tradeBookColumns.openTradeColumnOrder,value);
      this.setState({openTradeRowCount: count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOpenTrdSearchValue', component:"OpenTradeComponent"});
    }
  }
 refreshComponentData =()=>{
  try{
    this.props.openTrdRefreshFlag(true);
    this.props.getOpenTrdes();
    this.setState({selectedRowDocNo:''});
    this.setState({openTradeSearchValue:''});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'refreshComponentData', component:"OpenTradeComponent"});
  }
 }
cancelStatusModal = (event) => {
  try{
    this.setState({statusFlag:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'cancelStatusModal', component:"OpenTradeComponent"});
  }
}
openTrdColSelection = (data) => {
  try{
    if(parseInt(this.props.status) !== 0){
      this.setState({statusFlag:true});
      this.setState({enableOpentrdFlag:false});
      this.props.closeOpnTrdModifypopup(false);
    }
    else{
      this.props.closeOpnTrdModifypopup(true);
      this.setState({enableOpentrdFlag:true});
    }
    this.setState({selectedRowDocNo:data.tableRow.row.docNo});
    this.setState({selectedRowValues:data.tableRow.row});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'openTrdColSelection', component:"OpenTradeComponent"});
  }
}
openAllocateMdl = (data) => {
  try{
  // if(parseInt(this.props.status) !== 0){
  //    this.setState({statusFlag:true});
  //    this.setState({enableAllctMdlFlag:false});
  //   this.props.closeOpnTrdAllctMdl(false);
  //  }
  //  else{
     var fetchRecords = [];
     var fetchAvailableQty = [];
     var dealType=0;
     this.state.openTradeRows.forEach(function(row,key){
       if (row.deal !== data.tableRow.row.deal && row.cmdtyPair === data.tableRow.row.cmdtyPair) {
        fetchRecords=fetchRecords.concat(row);
       }
       if(row.docNo===data.tableRow.row.docNo){
         fetchAvailableQty=fetchAvailableQty.concat(row);
         if(row.deal==="BUY"){
            dealType=0;
          }else{
            dealType=1;
          }
       }
     });
     this.props.closeOpnTrdAllctMdl(true);
     this.setState({enableAllctMdlFlag:true, allocateRows:fetchRecords, fetchAvailableQty:fetchAvailableQty});
     this.props.getPhysicalsRecord(JSON.parse(localStorage.getItem("DFA")).C,dealType,data.tableRow.row.iid);
   // }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'openAllocateMdl', component:"OpenTradeComponent"});
  }
}
generateInvoice=(row)=>{
  try{
    var docNo=row.toString().split('""');
    var getdocType = row.toString().split('/');
    var docType=getdocType[0];
    if(docType !== 'PFC'){
      this.props.getInvoice(docNo,docType);
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'generateInvoice', component:"OpenTradeComponent"});
  }
}
closeAlertPopup=()=>{
  try{
    this.props.closeQtyAlertPopup(false);
    this.setState({isDisplayAlert: false})
    this.props.getAllOrdersTrd(JSON.parse(localStorage.getItem('DFA')).C)
    if(this.state.isWidgetRefresh){
      this.props.getAllOrdersTrd(JSON.parse(localStorage.getItem('DFA')).C)
    }
    this.setState({isWidgetRefresh: false})
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeAlertPopup', component:"OpenTradeComponent"});
  }
}
  
afterOpenModal() {
  try{
    const thisComponent = this.refs.errorMSG;
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    const elementsData = [
      {"classNames":"errorheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      {"classNames":"msgWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
    ];
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    const directionData = [
      {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"errorheader", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
      {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
    ];
    setDirection(thisComponent,directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[1], "classNames":"lmtClose"}
        //{"elmToHover":thisComponent.getElementsByClassName("dropdown-item")[0], "classNames":"dropdown-item"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"OpenTradeComponent"});
  }
}
render() {
const Cell = props => {
  const { column } = props;
  if (column.name === "Action" ) {
      return <HighlightedCell {...props} />;
  }
  if(column.name === "eventTime"){
      return <Table.Cell {...props} className="eventTimeCell"/>;
  }
  return <Table.Cell {...props} />;
};
const HighlightedCell = (props) => {
  return (
    <Table.Cell>
      <span>
        <a className='trdeBookCell' title="" onClick={()=>this.openTrdColSelection(props)} style={this.props.selectedLang.trdeBookCell}>
          Square-Off
        </a>
      </span>
      <span>
        <a className='allocateMdl' title="" onClick={()=>this.openAllocateMdl(props)} style={this.props.selectedLang.allocateMdl}>
          Allocate
        </a>
      </span>
    </Table.Cell>
  );
}
const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
const CloseIcon =<MUIIconWithTooltip icon={'Close'} className={'closeBtn'} title={i18next.t("close")}/>;
var OutstandingOrderHeader ='';
if(this.props.userDetail.fontSize == 'S'){
  OutstandingOrderHeader = 'tradeBookHeaderSfont';
}else if(this.props.userDetail.fontSize == 'N'){
  OutstandingOrderHeader = 'tradeBookHeaderMfont'
}else{
  OutstandingOrderHeader = 'tradeBookHeaderLfont'
}
const rowStyle = theme => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
    },
    '& tbody tr:nth-of-type(even)': {
      //backgroundColor: this.props.selectedCssColorTheme.listRowNext.background,
    },
    '& thead tr': {
      //backgroundColor: this.props.selectedCssColorTheme.trdbookHeader.background,
    },
    '& thead tr th': {
      //backgroundColor: this.props.selectedCssColorTheme.trdbookHeader.background,
    },
    '& .text-primary': {
      //color: this.props.selectedCssColorTheme.activeHeaderColor.color
    }
  },
});
  const dropDownListColor =theme =>({
    dropDownListHoverMenu:{
      '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        }
    }
  });
  const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu}  />
  );
  const MenuColor = props => (
      <ColumnChooser.Item {...props} />
  );

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table
    {...restProps}
    id="openTradeTable" className={classes.tableStriped}
  />
);

const TableRow = props => {
 const { row } = props;
 if(row.deal === "BUY" || row.deal === "STOP BUY"){
   return <Table.Row  {...props}  className="blue" />;
 }else {
   return <Table.Row  {...props}  className="red" />;
 }
};

const searchPlaceholderMsg = {
  searchPlaceholder: (i18next.t('search'))+'...',
};
var NoDataMsg = {
  noData: '',
}
if (this.state.refreshIconFlag === true) {
  NoDataMsg.noData = '';
}
else {
  NoDataMsg.noData = (i18next.t('noDataAvlMsg'));
}
const NoDataCell = props => (
  <Table.NoDataCell {...props} className="noDataCell"  />
);
return (
      <div className={`${styles.trdbody} ${selectedfont_size} ${this.props.language}`} style={this.props.selectedLang.trdbody}>
         <Modal isOpen={this.state.isDisplayAlert  && !this.props.opnTrdModifyFlag && this.state.displayMessage !==''} className={styles.warningModal}>
            <div  ref="errorMSG" className="OpntrdModifyWrap" >
               <div className={`${styles.header} errorheader`}>
                 <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
               <span onClick={this.closeAlertPopup} className="sqrOffErrCloseIcon closeIcon">{CloseIcon}</span>
               </div>
               <div className={`${styles.msg} commonMsgDir`}>
                 <h4>{i18next.t(this.state.displayMessage)}</h4>
              </div>
            </div>
          </Modal>
        {this.props.opnTrdModifyFlag && this.state.enableOpentrdFlag === true ?
          <Modal isOpen={this.props.opnTrdModifyFlag} id="modOpnTrdModal" className={styles.OpenTrdcontent}>
           <div ref="errorMSG" className="OpntrdModifyWrap" >
             <ModifyOpenTradeComponent selectLmtRow={this.state.selectedRowDocNo} selectedRow={this.state.selectedRowValues}/>
             </div>
          </Modal>
        :null}
        {this.props.opnTrdAllctFlag && this.state.enableAllctMdlFlag === true &&
          <Modal isOpen={this.props.opnTrdAllctFlag} id="opnTrdAllocModal" className={styles.allocationModal}>
           <div ref="errorMSG" className="OpntrdModifyWrap" >
              <OpenTradeAllocateComponent allocateRow={this.state.allocateRows} fetchAvailableQty={this.state.fetchAvailableQty}/>
            </div>
          </Modal>
        }
        {this.state.statusFlag === true ?
            <Modal isOpen={this.state.statusFlag} id="opnTrdErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
             <div  ref="errorMSG" className="mdlWrap" >
               <div className={`${styles.errorheader} errorheader`}>
                 <span className={`${styles.errormsgTitle}`}>{i18next.t("error")}</span>
               <span onClick={this.cancelStatusModal}  className="closeIcon">{CloseIcon}</span>
               </div>
               <div className={`${styles.msgWrap} msgWrap`}>
                 <h4>{i18next.t("noRatesMsg")}</h4>
              </div>
             </div>
           </Modal> : null
          }
          {this.state.disableModifyFlag === true ?
            <Modal isOpen={this.state.disableModifyFlag} id="opnTrdWrngModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
             <div ref="errorMSG" className="mdlWrap" >
               <div className={`${styles.errorheader} errorheader`}>
                 <span className={`${styles.errormsgTitle}`}>{i18next.t(this.state.OpntrdEditErrMsgHeader)}</span>
                 <span onClick={this.cancelDisableModifyModal} >{CloseIcon}</span>
               </div>
               <div className={`${styles.msgWrap} msgWrap`}>
                 <h4>{i18next.t(this.state.OpntrdEditErrMsg)}.</h4>
              </div>
              <div className={`${styles.btnWrap} col-md-12`}>
                <Button onClick={this.cancelDisableModifyModal} className='button-l' bsStyle="primary">{i18next.t("ok")}</Button>
             </div>
             </div>
           </Modal> : null
          }
        <div className={`${styles.refresh_icon} refresh_icon`}>
          <span onClick={this.refreshComponentData} id="lmtRefresh"><MUIIconWithTooltip icon={'Refresh'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("refresh")}/></span>
        </div>
        <div className={`${styles.openTradeRowsCount} openTradeRowsCount`} >
          <span className="trdbookText">{i18next.t("count")}</span>: <span>{this.state.openTradeRowCount}</span>
        </div>
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} ` + this.props.selectedCssColor} id="openTrdTbl">
            <Card>
            <Grid  style={{ height: '100%' }} rows={this.state.openTradeRows} columns={this.state.openTradeColumns}>
                  <DragDropProvider />
                  <SortingState columnExtensions={this.props.language === 'AR' ? this.state.openTradeColumnsExtensionsAR:this.state.openTradeColumnsExtensions} onSortingChange={this.onChangeOpenTrdColSorting} defaultSorting={[{ columnName: 'eventTime', direction: 'desc' }]} id="openTrdChngColSorting"/>
                  <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions}/>
                  <SearchState value={this.state.openTradeSearchValue} onValueChange={this.onChangeOpenTrdSearchValue} id="lmtChngOpenTrdSearchVal"/>
                  <IntegratedFiltering />
                  <Table cellComponent={Cell}
                    tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)}
                    height="auto" columnAutoWidth={true} rowComponent={TableRow} ColumnExtensions={this.props.language === 'AR' ? this.state.openTradeColumnsExtensionsAR:this.state.openTradeColumnsExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
                  <TableColumnReordering order={this.state.openTradeColumnOrder} onOrderChange={this.onChangeOpenTrdColOrder} id="lmtChngOpenTrdColOrd"/>
                  <TableHeaderRow showSortingControls/>
                  <TableColumnVisibility hiddenColumnNames={this.state.hiddenOpenTradeOrderColNames} onHiddenColumnNamesChange={this.onChangeHiddenOpenTrdCol} id="lmtChngHiddenOpenTrdColumn"/>
                  <Toolbar />
                  <SearchPanel messages={searchPlaceholderMsg}/>
                  <ColumnChooser containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor}/>
            </Grid>
            </Card>
          </div>
          {this.state.refreshIconFlag === true ?
              <div id="overlay" >
                  <i className="fa fa-spinner fa-spin spin-big"></i>
              </div>
          : null}
      </div>
    );
  }
}
